import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { BaseDirective, InstitutionsService } from './shared';

@Component({
  selector: 'app-four-oh-four',
  imports: [RouterLink],
  templateUrl: './404.component.html',
})
export class FourOhFourComponent extends BaseDirective {
  institutionsService = inject(InstitutionsService);

  siteName: string;

  constructor() {
    super();
    this._subscriptions.push(
      this.institutionsService.context.subscribe(
        (context) => (this.siteName = context.institutionSiteName),
      ),
    );
  }
}
